import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { Individual } from '@features/contacts/models/individual';
import { IndividualService } from '@features/contacts/services/individual.service';
import { TagService, TagEntityType } from '@features/opportunities/services/tag.service';
import { commandEvent } from '@shared/components/load/command/command.component';

import {
  Content,
  IndividualDetailsComponent
} from '../individual-details.component';

@Component({
  selector: 'spark-contacts-individual-new',
  templateUrl: '../individual-details.component.html'
})
export class IndividualNewComponent
  extends IndividualDetailsComponent
  implements OnInit
{
  readonly isNewEntity = true;

  get title(): string {
    return 'New Individual Contact';
  }
  get saveLabel(): string {
    return 'Create';
  }

  constructor(
    formBuilder: FormBuilder,
    individualService: IndividualService,
    private tagService: TagService
  ) {
    super(formBuilder, individualService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.update$ = commandEvent(this.change$, (delta) =>
      this.individualService.updateIndividual(this.individualId, delta).pipe(
        switchMap(() => {
          if (this.pendingTags.length === 0) {
            return of({});
          }
          const requests = this.pendingTags.map(tag => ({ tagId: tag.tagId, tagName: tag.tagName }));
          return this.tagService.addTagsToEntity(
            TagEntityType.Individuals, this.individualId, requests
          ).pipe(map(() => ({})));
        })
      )
    );
  }

  content(): Observable<Content> {
    return of({
      individual: {} as Individual.Model,
      contacts: []
    });
  }
}
